module.exports = __webpack_public_path__ + "img/product-placeholder-2.9e63d75.png";